import { takeEvery, call, put, select } from "redux-saga/effects";
import { buildGETUrl } from "../../utilities/buildGETUrl";
import {
  showAlertError,
  showAlertSuccess,
  showAlertInfo,
} from "../../store/Alert/actions";
import axios from "axios";
import { loading } from "../../store/App/actions";
import {
  loadPlaylist,
  UPDATE_MUSIC_POSITIONS,
  updatePlaylistsSongs,
} from "../../store/ContentPlaylists/actions";
import { fetchSongs } from "./loadPlaylist";
import { baseURL } from "../root";

export default function* () {
  yield takeEvery(UPDATE_MUSIC_POSITIONS, worker);
}

function* worker({ payload }) {
  console.log({ payload });

  yield put(loading(true));
  yield put(
    showAlertInfo({
      text: "Процесс может занять некоторое время",
    })
  );
  try {
    const added = yield call(fetchSet, payload);

    if (added.error) {
      yield put(
        showAlertError({
          errors: [`Ошибка сервера при ${UPDATE_MUSIC_POSITIONS}.`, added],
          text: "Композиция не была перемещена. Попробуйте повторить.",
        })
      );
    } else {
      // yield put(showAlertSuccess({
      //     text: "Список успешно изменен."
      // }))

      const { currentPlaylist } = yield select((state) => ({
        currentPlaylist: state.playlists.allPlaylists.find(
          (cur) => cur.id === state.playlists.selected[0]
        ),
      }));

      const { turn } = payload;

      const songs = turn
        .map((id) => currentPlaylist.songs.find((song) => song.id === id))
        .filter(Boolean); // на случай если в turn есть id, которого нет в songs

      yield put(
        updatePlaylistsSongs([
          {
            ...currentPlaylist,
            songs, // теперь массив
          },
        ])
      );
    }
  } catch (e) {
    yield put(
      showAlertError({
        errors: [`Ошибка сети при ${UPDATE_MUSIC_POSITIONS}.`, e],
        text: "Композиция не была перемещена. Попробуйте повторить.",
      })
    );
  } finally {
    yield put(loading(false));
  }
}

function fetchSet(addData) {
  console.log({ addData });

  let formData = new FormData();

  if (addData && (addData.songs || addData.turn)) {
    Object.keys(addData).forEach((name) => {
      // Исправленная проверка для пропуска поля 'id' (если это не turn запрос)
      if (addData.turn || name !== "id") {
        const value = addData[name];

        if (Array.isArray(value)) {
          // Для каждого элемента массива добавляем отдельное поле
          value.forEach((el, index) => {
            formData.append(`${name}[]`, el);
          });
        } else {
          formData.set(name, value);
        }
      }
    });
  }

  return axios({
    url: addData.turn
      ? `${baseURL}/playlist/tracks/turn/set`
      : `/playlist/set?id=${addData.playlist_id}`,
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }).then((response) => response.data);
}
